
export default {}

export function calcGridIncrement(leftBound, rightBound) {
  const gridOptions = [
    4000.0, 2000.0, 1000.0,  // Lines and labels would be more intuitive
    400.0,  200.0,  100.0,   // if we replaced the 4's with 5's
    40.0,   20.0,   10.0,
    4.0,    2.0,    1.0,
    0.4,    0.2,    0.1,
    0.04,   0.02,   0.01
  ]
  const grid = 10
  let low = leftBound
  let high = rightBound

  if(leftBound > rightBound) {
    high = leftBound
    low = rightBound
  }

  let roughIncrement = (high - low) / grid
  let increment

  for (let [index, gridOption] of gridOptions.entries()) {
    if(roughIncrement === gridOption) {
      increment = gridOption
    } else if(roughIncrement < gridOption) {

      if(index > 0) {
        increment = gridOptions[index + 1]
      } else {
        increment = gridOptions[index]
      }
    }
  }
  return increment
}

export function generateGridLinePositions(leftBound, rightBound, increment) {
  let low = leftBound
  let high = rightBound
  let suggestionSet = []

  if(leftBound > rightBound) {
    high = leftBound
    low = rightBound
  }

  // Start first line at an multiple of the increment
  // E.g. if range is [14, 137] start at 20.
  // We need modulo to calculate the lowest multiple.
  let modulo = low % increment

  for(let i = low + increment - modulo; i < high; i += increment) {
    // normal label and extreme labels shouldn't be to close to each other
    let smallestDistance = Math.min(Math.abs(low - i), Math.abs(high - i))
    if (smallestDistance < increment/4)
      continue

    suggestionSet.push(i)
  }
  return suggestionSet
}

export function closestPointInGrid(point, gridLines) {
  let mid
  let lo = 0
  let hi = gridLines.length - 1
  while (hi - lo > 1) {
    mid = Math.floor ((lo + hi) / 2)
    if (gridLines[mid] < point) {
      lo = mid
    } else {
      hi = mid
    }
  }
  if (point - gridLines[lo] <= gridLines[hi] - point) {
    return gridLines[lo]
  }
  return gridLines[hi]
}

export function getLabelCount(gridPointCount) {
  // Algorithm copied and adapted from generateGrid() in sliderGrid.js
  // It's called labelCount there but it doesn't really define the nrs of labels.
  // If we would call it x then every xth gridPoint should have an label.
  let labelCount = 0

  if (gridPointCount <= 5) {
    labelCount = 1
  } else {
    labelCount = Math.round(gridPointCount * 0.1)
    if (window.innerWidth <= 1000){
      labelCount = Math.round(gridPointCount * 0.5)
    }
    if (labelCount % 2 !== 0 && labelCount % 5 !== 0 && labelCount > 1)
      labelCount--
    if (labelCount === 6 || labelCount === 4)
      labelCount = 5
    if (labelCount === 8)
      labelCount = 10
  }
  return labelCount
}
